/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class WorkflowEvents {
        private logType: string = "WorkflowEvents";

        private drawingInstance: models.WorkflowDrawingInstance;
        private drawingScope: ng.IScope;
        private drawingService: services.WorkflowDrawingService;

        private currentlyDragging: boolean;
        private currentDragX: number;
        private currentDragY: number

        constructor(drawingInstance: models.WorkflowDrawingInstance, drawingScope: ng.IScope, drawingService: services.WorkflowDrawingService) {
            this.drawingInstance = drawingInstance;
            this.drawingScope = drawingScope;
            this.drawingService = drawingService;
            this.addEntireCanvasMouseMoveHandler();
            this.addMouseWheelHandler();
            this.setupDragAndPan();
            this.currentlyDragging = false;
        }

        public getWorkflowHoverContext(event: any): models.WorkflowHoverContext {
            var target = event.target;

            var workflowBlockSelected = false;
            var deleteOptionHovered = false;
            var settingsOptionHovered = false;

            var targetChanged = false;
            var originalLocalName;

            if (target && target.attributes['data-class'] && target.attributes['data-class'].value == 'in-between-drop-zone') {
                var fromWorkflowBlockId: string;
                var toWorkflowBlockId: string;

                var fromWorkflowBlock: models.IWorkflowBlock;
                var toWorkflowBlock: models.IWorkflowBlock;
                var inBetweenIndex: number;

                if (target.attributes['data-from-id']) {
                    fromWorkflowBlockId = target.attributes['data-from-id'].value;
                    fromWorkflowBlock = this.drawingInstance.getWorkFlowBlockById(fromWorkflowBlockId);
                }

                if (target.attributes['data-to-id']) {
                    toWorkflowBlockId = target.attributes['data-to-id'].value;
                    toWorkflowBlock = this.drawingInstance.getWorkFlowBlockById(toWorkflowBlockId);
                }

                if (target.attributes['data-index']) {
                    inBetweenIndex = parseInt(target.attributes['data-index'].value);
                }

                return new models.WorkflowHoverContext(undefined, false, false, false, true, inBetweenIndex, fromWorkflowBlock, toWorkflowBlock);
            }

            // Reset target to actual workflow block if label or option is selected
            if (target.parentNode &&
                (target.localName == "text" || target.localName == "image" ||
                    (target.localName == "rect" && (!target.attributes['data-class'] || target.attributes['data-class'].value != 'workflowBlock')))) {
                originalLocalName = target.localName;
                targetChanged = true;

                var siblings: Array<any> = target.parentNode.childNodes;
                target = Enumerable.from(siblings).singleOrDefault(i => i.attributes['data-class'] && i.attributes['data-class'].value == 'workflowBlock')
            }

            if (target && target.localName == "image" && target.attributes['data-class'] && target.attributes['data-class'].value == 'optionsImage') {
                deleteOptionHovered = target.attributes['data-id'] && target.attributes['data-id'].value == 'delete';
                settingsOptionHovered = target.attributes['data-id'] && target.attributes['data-id'].value == 'settings';
            }

            var workflowBlock: models.IWorkflowBlock;

            if (target && target.attributes['data-class'] && target.attributes['data-class'].value == 'workflowBlock') {

                var workflowBlockId: string;

                var blockTypes = models.WorkflowBlockManager.getValidBlockTypes();

                if (target.attributes['data-id'] && target.attributes["id"] && blockTypes.indexOf(target.attributes['data-id'].value) !== -1) {
                    workflowBlockId = target.attributes["id"].value;
                }

                if (workflowBlockId) {
                    workflowBlock = this.drawingInstance.getWorkFlowBlockById(workflowBlockId);
                    workflowBlockSelected = !targetChanged || originalLocalName == "text" || originalLocalName == "image";
                }
            }

            return new models.WorkflowHoverContext(workflowBlock, workflowBlockSelected, deleteOptionHovered, settingsOptionHovered);
        }

        private addEntireCanvasMouseMoveHandler(): void {
            var mainSnapElement = Snap.select('#' + this.drawingInstance.svgElementId);
            var self = this;
            mainSnapElement.mousemove((evt) => self.mousemoveHandler(evt));
        }

        private mousemoveHandler(event) {
            var hoverContext = this.getWorkflowHoverContext(event);
            this.hoverEnd(hoverContext.workflowBlock);

            if (!hoverContext.workflowBlock) return;
            if (hoverContext.workflowBlock.type != Wars.Domain.Model.Codes.Enums.BlockType.DropZone) {
                hoverContext.workflowBlock.hoverStart();
            }
        }

        private hoverEnd(currentWorkflowBlock: models.IWorkflowBlock): void {
            for (var i = 0; i < this.drawingInstance.blockLocations.length; i++) {
                var currentBlock = this.drawingInstance.blockLocations[i].workflowBlock;
                if (currentBlock.type != Wars.Domain.Model.Codes.Enums.BlockType.DropZone && (!currentWorkflowBlock || (currentBlock.id !== currentWorkflowBlock.id))) {
                    currentBlock.hoverEnd();
                }
            }
        }

        private addMouseWheelHandler(): void {
            var svg = document.getElementById(this.drawingInstance.svgElementId);
            if (svg.addEventListener) {
                // IE9, Chrome, Safari, Opera
                svg.addEventListener("mousewheel", (event) => this.mouseWheelHandler(event), false);
                // Firefox
                svg.addEventListener("DOMMouseScroll", (event) => this.mouseWheelHandler(event), false);
            }
            // IE 6/7/8
            else (<any>svg).attachEvent("onmousewheel", (event) => this.mouseWheelHandler(event));
        }

        private mouseWheelHandler(event: any): boolean {
            // cross-browser wheel delta
            event = event.originalEvent || event;
            var mouseWheelDelta = Math.max(-1, Math.min(1, (event.wheelDelta || -event.detail)));
            var currentZoomPercentage = this.drawingInstance.settings.zoomPercentage;
            var delta = this.drawingInstance.settings.zoomStep * mouseWheelDelta;

            services.WarsLogger.logDebug("Mouse Wheel Delta: " + delta, this.logType);

            if (this.drawingScope) {
                this.drawingScope.$apply(() => {
                    if (delta > 0) {
                        this.drawingInstance.settings.zoomPercentage = Math.min(this.drawingInstance.settings.maxZoomPercentage, this.drawingInstance.settings.zoomPercentage + delta);
                    } else {
                        this.drawingInstance.settings.zoomPercentage = Math.max(this.drawingInstance.settings.minZoomPercentage, this.drawingInstance.settings.zoomPercentage + delta);
                    }
                });
            }

            this.changeViewBoxSizeAndOffset();

            event.preventDefault();
            return false;
        }

        private setupDragAndPan(): void {
            this.addMouseDownForDragPanning();
            this.addMouseUpForDragPanning();
            this.addMouseMoveHandlerForDragPanning();
        }

        private addMouseDownForDragPanning(): void {
            var svg = document.getElementById(this.drawingInstance.svgElementId);
            if (svg.addEventListener) {
                svg.addEventListener("mousedown", (event) => this.mouseDownHandler(event), false);
            }
            // IE 6/7/8
            else (<any>svg).attachEvent("mousedown", (event) => this.mouseDownHandler(event));
        }

        private mouseDownHandler(event: any) {
            var svgElement = document.getElementById(this.drawingInstance.svgElementId);

            var classAttr = svgElement.getAttribute('class');
            classAttr = classAttr.replace('not-dragging', 'dragging');
            svgElement.setAttribute('class', classAttr);

            this.currentlyDragging = true;
            this.currentDragX = event.screenX;
            this.currentDragY = event.screenY;
        }

        private addMouseUpForDragPanning(): void {
            var svg = document.getElementById(this.drawingInstance.svgElementId);
            if (svg.addEventListener) {
                svg.addEventListener("mouseup", (event) => this.mouseUpHandler(event), false);
            }
            // IE 6/7/8
            else (<any>svg).attachEvent("mouseup", (event) => this.mouseUpHandler(event));
        }

        private mouseUpHandler(event: any) {
            var svgElement = document.getElementById(this.drawingInstance.svgElementId);

            var classAttr = svgElement.getAttribute('class');
            classAttr = classAttr.replace('dragging', 'not-dragging');
            svgElement.setAttribute('class', classAttr);

            this.currentlyDragging = false;
        }

        private addMouseMoveHandlerForDragPanning(): void {
            var svg = document.getElementById(this.drawingInstance.svgElementId);
            if (svg.addEventListener) {
                svg.addEventListener("mousemove", (event) => this.mouseMoveHandler(event), false);
            }
            // IE 6/7/8
            else (<any>svg).attachEvent("mousemove", (event) => this.mouseMoveHandler(event));
        }

        private mouseMoveHandler(event: any) {
            // Only need to process the mouse move if currently dragging
            if (!this.currentlyDragging) return;

            var rateOfDrag = 1;

            var xDelta = (this.currentDragX - event.screenX) * rateOfDrag;
            var yDelta = (this.currentDragY - event.screenY) * rateOfDrag;

            var dragOffsetCoordinate = this.getDragOffset(xDelta, yDelta);

            // If mouse has not move enough no need to do anything
            if (dragOffsetCoordinate.x === this.drawingInstance.settings.xOrigin && dragOffsetCoordinate.y === this.drawingInstance.settings.yOrigin) return;

            this.currentDragX = event.screenX;
            this.currentDragY = event.screenY;

            if (this.drawingScope) {
                this.drawingScope.$apply(() => {
                    this.drawingInstance.settings.xOrigin = dragOffsetCoordinate.x;
                    this.drawingInstance.settings.yOrigin = dragOffsetCoordinate.y;
                    this.changeViewBoxSizeAndOffset();
                });
            }
        }

        private getDragOffset(xDelta: number, yDelta: number): models.Coordinate {
            var xSteps = Math.floor(xDelta);
            var xOffset = this.drawingInstance.settings.xOrigin + xSteps;
            var xOrigin = Math.min(this.drawingInstance.settings.horizontalMax, Math.max(xOffset, this.drawingInstance.settings.horizontalMin));

            var ySteps = Math.floor(yDelta);
            var yOffset = this.drawingInstance.settings.yOrigin + ySteps;
            var yOrigin = Math.min(this.drawingInstance.settings.verticalMax, Math.max(yOffset, this.drawingInstance.settings.verticalMin));

            return new models.Coordinate(xOrigin, yOrigin);
        }

        private changeViewBoxSizeAndOffset(): void {
            this.drawingService.changeViewBoxSizeAndOffset(
                this.drawingInstance.paper,
                this.drawingInstance.settings.xOrigin,
                this.drawingInstance.settings.yOrigin,
                this.drawingInstance.settings.getViewBoxWidth(),
                this.drawingInstance.settings.getViewBoxHeight());
        }
    }
}